import api from "./api";

const ordersCrmService = {};
const endpoint = "/indication-crm";

ordersCrmService.list = function (params) {
  return api.get(endpoint, { params }).then(({ data }) => data);
};

ordersCrmService.listProviders = function () {
  return api.get(`${endpoint}/providers`).then(({ data }) => data);
};

ordersCrmService.listCoverages = function () {
  return api.get(`${endpoint}/coverages`).then(({ data }) => data);
};

ordersCrmService.counts = function (params) {
  return api.get(`${endpoint}/counts`, { params }).then(({ data }) => data);
};

ordersCrmService.stats = function (params) {
  return api.get(`${endpoint}/stats`, { params }).then(({ data }) => data);
};

ordersCrmService.updateStatus = function (id, status, note) {
  return api
    .post(`${endpoint}/${id}/status`, { status, note })
    .then(({ data }) => data);
};

ordersCrmService.updateObservations = function (id, observations) {
  return api
    .put(`${endpoint}/${id}/observations`, { observations })
    .then(({ data }) => data);
};

ordersCrmService.exportCsv = function (params) {
  return api
    .get(`${endpoint}/export`, { params, responseType: "blob" })
    .then(({ data }) => data);
};

export default ordersCrmService;
